import type { FaireProductEntity } from "../../entity_types/product";

export const p_umkdq3yphg: FaireProductEntity = {
  token: "p_umkdq3yphg",
  type: "product",
  name: "Birthday Bitch Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/97d91f7e7303d6867a65dd73cf0e8f46073f68e16a7f190ef8d1c9a95f77621f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2091d1b93c6b6acf17a83e8979926143b34c8844c0e52db43637d0e97f5d99f3.jpeg",
    "https://cdn.faire.com/fastly/61936c7cb260eea6defd0e6cf5008361519424278f9be5833485eb328fbedb80.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/af4592d359308bd708a5c62956410b2fb42ffa43a79b705eb98fa51751262a84.jpeg",
    "https://cdn.faire.com/fastly/2789075071b6eae4d1436e01c0e9c5573ffbbd19c02efef07366563ed33b9eb0.jpeg"
  ],
  priceDollars: 6.75,
  description: "When it's your special day, you can be however you wanna be. These socks are designed to gently caress the perfect, supple feet of the honored BIRTHDAY BITCH 🎂 😝 😈  \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:25.916Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
